import { render, staticRenderFns } from "./CompanyMultiRestaurantReport.vue?vue&type=template&id=2f913cd2"
import script from "./CompanyMultiRestaurantReport.vue?vue&type=script&lang=js"
export * from "./CompanyMultiRestaurantReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports